import { useApplicationContext } from '~/shared/context/use-application-context';
import type { LanguageCode } from '~/shared/internationalization';

/** The UI language as a BCP 47 tag, for number formatting and the Accept-Language of content reads. */
export const useLocale = (): LanguageCode => {
    const {
        applicationState: { language },
    } = useApplicationContext();

    return language.code;
};
